/** 写接口令牌（dual-entry 规则 9 / 10，#5004）。
 *
 * - 令牌由操作员在设置屏输入一次，只存本机浏览器（localStorage）；构建期不嵌明文、服务端不下发。
 * - 读写都包 try/catch：隐私窗口 / 禁用站点数据时 localStorage 可能抛错或为空，此时当作「未设置」，
 *   写请求会被服务端 401，界面提示去设置屏填写——不静默失败。
 * - 只给写请求用；只读 GET 与事件流不带令牌。
 */

export const TOKEN_STORAGE_KEY = "someo-keel.api-token";

/** 401 时给操作员的统一提示。 */
export const UNAUTHORIZED_HINT = "令牌缺失或无效，去设置屏填写";

type TokenStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function defaultStorage(): TokenStorage | null {
  try {
    return typeof globalThis.localStorage === "undefined" ? null : globalThis.localStorage;
  } catch {
    return null;
  }
}

export function readApiToken(storage: TokenStorage | null = defaultStorage()): string | null {
  try {
    const value = storage?.getItem(TOKEN_STORAGE_KEY);
    return value && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
}

/** 存令牌；空串等于清除。返回是否写成功（存储不可用时为 false）。 */
export function writeApiToken(token: string, storage: TokenStorage | null = defaultStorage()): boolean {
  const value = token.trim();
  if (!storage) return false;
  try {
    if (value) storage.setItem(TOKEN_STORAGE_KEY, value);
    else storage.removeItem(TOKEN_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}

export function clearApiToken(storage: TokenStorage | null = defaultStorage()): boolean {
  return writeApiToken("", storage);
}
